export const tilesConstant = {
  childHeaderText: 'PROCESS AUDIT PLAN',
};
